export class Game {
  constructor() {
    this.rewardPool = 30
    this.wincount = 0
    this.round = 1
    this.gambingRecord = []
    for (let i = 0; i < 14; i++) {
      this.gambingRecord.push([])
    }
  }
  getRoundReward() {
    if (this.round <= 3) {
      return 30
    }
    if (this.round <= 5) {
      return 50
    }
    if (this.round <= 7) {
      return 100
    }
    return 100
  }
  cardEvent(actioner, losers) {
    if (losers.length === 0) {
      this.rewardPool += 10
      actioner.skip()
    } else {
      this.wincount++
      actioner.win(this.rewardPool)
      losers.forEach((loser) => {
        loser.lose()
      })
      this.rewardPool = 30
    }
  }
  gamblingEvent(actioner, position) {
    actioner.gambling()
    this.rewardPool += 10
    this.gambingRecord[position].push(actioner.id)
  }
  wrongCardEvent(actioner) {
    this.rewardPool += actioner.wrongCard()
  }
  roundEnd(gamers) {
    let gamblingWin = []
    this.rewardPool += this.getRoundReward()
    if (this.gambingRecord[this.wincount].length == 1) {
      let winner = gamers[this.gambingRecord[this.wincount][0]]
      winner.roundReward(this.rewardPool)
      gamblingWin = [winner]
    } else if (this.gambingRecord[this.wincount].length == 2) {
      let winner01 = gamers[this.gambingRecord[this.wincount][0]]
      let winner02 = gamers[this.gambingRecord[this.wincount][1]]
      let token = Math.ceil(this.rewardPool / 20) * 10
      winner01.roundReward(token)
      winner02.roundReward(this.rewardPool - token)
      gamblingWin = [winner01, winner02]
    }
    this.round++
    this.wincount = 0
    this.rewardPool = 30
    gamers.forEach((gamer) => {
      gamer.reset()
    })
    this.gambingRecord = []
    for (let i = 0; i < 14; i++) {
      this.gambingRecord.push([])
    }
    return gamblingWin
  }
}

export class Gamer {
  constructor(id, name) {
    this.id = id
    this.name = name
    this.money = 70
    this.card = 6
  }
  reset() {
    this.card = 6
  }
  gambling() {
    this.money -= 10
  }
  skip() {
    this.money -= 10
    this.card--
  }
  win(reward) {
    this.money += reward
    this.card--
  }
  lose() {
    this.card--
  }
  wrongCard() {
    this.money -= 20
    return 20
  }
  roundReward(money) {
    this.money += money
  }
}
